import type { ReactNode, Ref } from 'react';
import { Flex } from '../Flex';

type Props<Ui> = {
  containerRef: Ref<HTMLDivElement>;
  visible: boolean;
  data: Ui | undefined;
  isLoading: boolean;
  renderSkeleton: () => ReactNode;
  renderContent: (data: Ui) => ReactNode;
};

const AsyncTreeNodeChips = <Ui,>({
  containerRef,
  visible,
  data,
  isLoading,
  renderSkeleton,
  renderContent,
}: Props<Ui>) => (
  <Flex ref={containerRef} sx={{ alignItems: 'center', ml: 3 }}>
    {!visible || isLoading || data === undefined
      ? renderSkeleton()
      : renderContent(data)}
  </Flex>
);

export default AsyncTreeNodeChips;
